export enum EnumTresPuntos {
  Unidades,
  TiposDeInsumo,
  Familias,
  Estados,
  Ciudades,
  Proveedores,
  Responsables,
  Clientes,
  Empresas,
  Calendarios,
  Vendedores,
  TiposDeLicitaciones,
  Monedas,
  ContactoCliente,
  Region,
  CatalogoGeneral,
  TipoAnticipo,
  ProgramaDeObra,
  TipoDeJornadas,
  AnioPorcentajeAplicacion,
  Materiales,
  Fechas,
  Partidas
}

export enum EnumFiltroCatGeneral {
  MuestraTodo = 1,
  NoMuestraPorcentajes = 2,
  SoloMuestraAgrupadores = 3,
  SoloMuestraMateriales = 4,
  SoloMuestraManoDeObra = 5,
  SoloMuestraEquipos = 6,
  SoloTipo4 = 7
}
